import type { NormalisedCampaign } from "@onhandtech/onhand-fe-shared/lib/api/v5/campaign/campaign.types";
import type { ContentPublishStatus } from "constants/publish-status";

export const moduleName = "campaigns";

export type CampaignModalType = "delete-campaign" | "permissions" | "unpublish";

export type ModalCampaigns = Record<
	CampaignModalType,
	NormalisedCampaign | null
>;

export type CampaignState = {
	activeFilterType: ContentPublishStatus;
	draftCampaign: NormalisedCampaign | null;
	selectedCampaign: NormalisedCampaign | null;
	modals: ModalCampaigns;
	pagination: {
		pageNumber: number;
	};
};
